import {getAllAddress, getDetailAddress} from "../network/addressApi";
import addressStore from "../store/addressStore";

export const fetchAddressById = async (id) => {
    const {setDetailAddress} = addressStore.getState();
    try {
        const response = await getDetailAddress(id);
        if (response?.success) {
            setDetailAddress(response?.data);
        }
        return response;
    } catch (error) {
        console.error("Failed to fetch services", error);
    }
};
export const fetchAddresses = async (params) => {
    const {setAddresses} = addressStore.getState();
    try {
        const response = await getAllAddress(params);
        if (response?.success) {
            setAddresses(response.data);
        }
        return response?.data;
    } catch (error) {
        console.error("Failed to fetch services", error);
    }
};